import {
  FirestoreDataConverter,
  QueryDocumentSnapshot,
} from 'firebase/firestore';
import { FcmToken } from 'shared/types/fcm-token';

import { firebaseTimestampToDate } from './firebase-timestamp-to-date';

export const fcmTokenConverter: FirestoreDataConverter<FcmToken> = {
  fromFirestore: (snapshot: QueryDocumentSnapshot): FcmToken => {
    const data = snapshot.data();
    return {
      ...data,
      id: data.token,
      updatedAt: data.updatedAt
        ? firebaseTimestampToDate(data.updatedAt)
        : undefined,
    } as FcmToken;
  },
  toFirestore: (fcmToken) => fcmToken,
};
